export const PAGE_OPTIONS = Object.freeze([5, 10, 20, 50]);